import { z } from 'zod/v4';

/**
 * Represents a font size value in pixels. When `undefined`, the font size is
 * determined automatically based on the available space.
 */
export type FontSizeOption = z.infer<typeof fontSizeOptionSchema>;
export const fontSizeOptionSchema = z.number().optional();
